import { lang } from '@umu/ukit-lang';
import { getLangSwitchList } from '@umu/umu-lang-switch';
/**
 * @description menuIItem
 * @author duanjun
 */

import React, { useState, useEffect, useCallback } from 'react';
import './menuItemLangSwitch.scss';
import API from '@umu/umu-api';
import { $location } from '@umu/umu-dom';
import { fetch } from '@umu/umu-fetch';
import { ISystemConfig } from '@umu/umu-types';

import { components } from 'common';
const { If, Portal } = components;

import IUserMenuController from '../userMenuController';
import ConfigurableHeader from '../../@configurableHeader/configurableHeader';
import CoverPage from '../../@coverPage/coverPage';

let defaultConfig = {} as ISystemConfig;

function useSystemConfig() {
    const [config, setConfig] = useState(defaultConfig);
    useEffect(() => {
        fetch.get(API.Path.GET_SYS_CONFIG.url).then((response: { data: ISystemConfig }) => {
            defaultConfig = response.data;
            setConfig(response.data);
        });
    }, []);
    return config;
}

const langSwitchList = getLangSwitchList();

function isLogin() {
    const umuId = (window as any)?.pageData?.data?.user_info?.umu_id || 0;
    return parseInt(umuId, 10) > 0;
}
/**
 * 设置系统语言偏好
 * @param {string}    lang     zh-cn 等
 */
function updateLang(lang: { key: string, value: string }, domain: string) {
    const date = new Date();
    date.setFullYear(date.getFullYear() + 10);
    document.cookie = '_lang=' + lang.key + ';expires=' + date.toUTCString() + ';domain=' + domain + ';path=/;';
    if (isLogin()) {
        return fetch.post(API.Path.UPDATE_USER_SETUP.url, {
            option_type: 7,
            option_value: lang.key,
        });
    } else {
        return Promise.resolve();
    }
}

interface ILangSwitchProps {
    controller: IUserMenuController;
}

export default function LangSwitch(props: ILangSwitchProps) {
    const config = useSystemConfig();
    const [isShow, setIsShow] = useState(false);
    const [selectedLang, setSelectLang] = useState(langSwitchList.find(item => item.key === config.lang) || langSwitchList[0]);
    const closePanel = useCallback(_closePanel, [isShow]);
    const openPanel = useCallback(_openPanel, [isShow]);
    const controller = props.controller;

    // 修复m站切换多语言时多语言language默认光标位置不对问题 https://app.asana.com/0/357313196454880/1201083146279330
    useEffect(() => {
        setSelectLang(langSwitchList.find(item => item.key === config.lang) || langSwitchList[0]);
    }, [config]);

    function _openPanel() {
        setIsShow(true);
        if (controller) {
            controller.hide();
        }
    }

    function _closePanel() {
        setIsShow(false);
        if (controller) {
            controller.show();
        }
    }

    function save() {
        updateLang(selectedLang, config.site_host).then(() => {
            $location.reload();
        });
    }

    function getHeaderConfig() {
        const headerConfig = {
            leftProp: {
                label: lang('取消'),
                clsName: 'btn-text',
                callback: closePanel,
            },
            centerProp: {
                label: lang('多语言language'),
                clsName: 'btn-text',
            },
            rightProp: {
                label: lang('完成'),
                clsName: 'btn-text',
                callback: save,
            },
        };
        return headerConfig;
    }

    function renderLangList() {
        return langSwitchList.map((langItem, index) => {
            return (
                <li key={index} className="lang-item" onClick={() => setSelectLang(langItem)}>
                    <If condition={langItem === selectedLang}>
                        <span className="is-checked"></span>
                    </If>
                    <span className="lable">{langItem.value}</span>
                </li>
            );
        });
    }

    function renderlangPanel() {
        if (!isShow) {
            return null;
        }
        return (
            <Portal preventBodyScroll={true}>
                <CoverPage clsName="lang-switch-panel-cover-page">
                    <div className="lang-switch-panel">
                        <div className="panel-shadow"></div>
                        <div className="lang-switch">
                            <div className="lang-header-container">
                                <ConfigurableHeader clsName="lang-switch-header" config={getHeaderConfig()} />
                            </div>
                            <div className="lang-list">
                                <ul>{renderLangList()}</ul>
                            </div>
                        </div>
                    </div>
                </CoverPage>
            </Portal>
        );
    }

    function render() {
        return (
            <div className="lang-switch-menu-item">
                <div onClick={openPanel}>
                    <span className="item-label">{lang('多语言language')}</span>
                    <span className="item-value">
                        <span>{selectedLang.value}</span>
                        <i className="icon icon-arrow arrow1 gray right size-xs" />
                    </span>
                </div>
                {renderlangPanel()}
            </div>
        );
    }

    return render();
}
